import React, { Component, Fragment } from "react";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { createReport } from "../../actions/companyEmployeeShiftActions";
import { getActiveShift } from "../../actions/shiftActions";
import { getCompanyEmployee } from "../../actions/companyActions";
import { Grid, Button } from "@material-ui/core";

import { TextField } from "@material-ui/core";
import Form from "./Form";

import moment from "moment";
import _ from "lodash";

import ReportLine from "../ReportLine";
import SignaturePad from "../SignaturePad";

import ConfirmationDialog from "../ConfirmationDialog";

import { KeyboardDatePicker, KeyboardTimePicker } from "@material-ui/pickers";
import { AppContext } from "../../contexts";
import openInNewTab from "../../utils/open-in-new-tab";

import { v4 as uuidv4 } from "uuid";

class CreateReportForm extends Component {
  state = {
    isDialogOpen: false,
    projectName: "",
    beginDate: moment(),
    beginTime: moment(),
    endTime: moment(),

    lines: [
      {
        id: uuidv4(),
        time: null,
        remarks: "",
      },
    ],
    signature: "",
  };

  componentDidMount = async () => {
    const [shift, ce] = await Promise.all([
      this.props.getActiveShift(this.props.shiftId),
      this.props.getCompanyEmployee(
        this.props.companyEmail,
        this.props.employeeEmail,
      ),
    ]);

    const ceShift = shift.employees.find(
      (ces) => ces.CompanyEmployeeShift.CompanyEmployeeId == ce.companies[0].id,
    );

    const beginDatetime =
      ceShift.CompanyEmployeeShift.startDateTime || shift.beginDatetime;
    const endDateTime =
      ceShift.CompanyEmployeeShift.endDateTime || shift.endDatetime;

    this.setState({
      projectName: shift.project.name,
      beginDate: moment(beginDatetime),
      beginTime: moment(beginDatetime),
      endTime: moment(endDateTime),
    });
  };

  onClickDeleteLine = (id) => {
    const lines = this.state.lines.filter((line) => line.id !== id);
    this.setState({ lines });
  };

  onChangeLine = (id, data) => {
    const lines = this.state.lines.map((line) =>
      line.id === id ? { ...line, ...data } : line,
    );
    this.setState({ lines });
  };

  handleChangeOnLine = (id, e) => {
    const lines = this.state.lines.map((line) =>
      line.id === id ? { ...line, [e.target.name]: e.target.value } : line,
    );
    this.setState({ lines });
  };

  onSubmit = (e) => {
    e.preventDefault();
    this.setState({ isDialogOpen: true });
  };

  onConfirmed = async () => {
    this.setState({ isDialogOpen: false });
    this.props
      .createReport(
        this.props.companyEmail,
        this.props.employeeEmail,
        this.props.shiftId,
        this.state,
      )
      .then((file) =>
        openInNewTab(`${process.env.REACT_APP_API.trim()}/file/${file.id}`),
      );
  };

  render() {
    return (
      <AppContext.Consumer>
        {(settings) => (
          <Fragment>
            <Form
              onSubmit={this.onSubmit}
              submitText="Indienen"
              isFetching={this.props.isFetching}
              successMessage={this.props.successMessage}
              errorMessage={this.props.errorMessage}
            >
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <img className="logo" alt="" src={settings.logo} />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    id="projectName"
                    name="projectName"
                    label="Project"
                    value={this.state.projectName}
                    onChange={this.handleChange}
                    fullWidth
                    disabled
                  />
                  <KeyboardDatePicker
                    clearable
                    format="DD-MM-YYYY"
                    id="beginDate"
                    name="beginDate"
                    label="Datum dienst *"
                    value={this.state.beginDate}
                    onChange={this.handleChange}
                    fullWidth
                    ampm={false}
                    disabled
                  />
                  <KeyboardTimePicker
                    clearable
                    format="HH:mm"
                    id="beginTime"
                    name="beginTime"
                    label="Aanvang dienst *"
                    value={this.state.beginTime}
                    onChange={this.handleChange}
                    fullWidth
                    ampm={false}
                    disabled
                  />
                  <KeyboardTimePicker
                    clearable
                    format="HH:mm"
                    id="endTime"
                    name="endTime"
                    label="Einde dienst *"
                    value={this.state.endTime}
                    onChange={this.handleChange}
                    fullWidth
                    ampm={false}
                    disabled
                  />
                </Grid>

                <Grid item xs={2} sm={2}>
                  <p>Tijdstip</p>
                </Grid>

                <Grid item xs={10} sm={10}>
                  <p>Rapportage</p>
                </Grid>

                {(() => {
                  const shiftTime = moment(this.state.beginTime).format(
                    "HH:mm",
                  );

                  const sorted = [...this.state.lines].sort((a, b) => {
                    const timeA = a.time
                      ? moment(a.time, "HH:mm").format("HH:mm")
                      : null;
                    const timeB = b.time
                      ? moment(b.time, "HH:mm").format("HH:mm")
                      : null;

                    if (!timeA) return 1;
                    if (!timeB) return -1;

                    return timeA.localeCompare(timeB);
                  });

                  const [after, before] = _.partition(
                    sorted.filter((line) => line.time),
                    (line) =>
                      moment(line.time, "HH:mm").format("HH:mm") >= shiftTime,
                  );

                  const nullOrEmpty = sorted.filter((line) => !line.time);

                  const finalSorted = [...after, ...before, ...nullOrEmpty];

                  return finalSorted.map((line, i) => (
                    <ReportLine
                      key={line.id}
                      index={i}
                      line={line}
                      handleChangeOnLine={this.handleChangeOnLine}
                      onClickDeleteLine={this.onClickDeleteLine}
                      onChangeLine={this.onChangeLine}
                    />
                  ));
                })()}

                <Button
                  color="primary"
                  onClick={() =>
                    this.setState({
                      lines: [
                        ...this.state.lines,
                        { id: uuidv4(), time: null, remarks: "" },
                      ],
                    })
                  }
                >
                  Nieuwe lijn
                </Button>

                <Grid item xs={12} sm={12}>
                  <SignaturePad
                    onChange={(signature) => this.setState({ signature })}
                  />
                </Grid>
              </Grid>
            </Form>
            <ConfirmationDialog
              title={"Weet u het zeker?"}
              open={this.state.isDialogOpen}
              onConfirmed={this.onConfirmed}
              onClose={() => this.setState({ isDialogOpen: false })}
            />
          </Fragment>
        )}
      </AppContext.Consumer>
    );
  }
}

CreateReportForm.propTypes = {
  createReport: PropTypes.func.isRequired,
  getActiveShift: PropTypes.func.isRequired,
  getCompanyEmployee: PropTypes.func.isRequired,
  successMessage: PropTypes.string,
  errorMessage: PropTypes.arrayOf(PropTypes.string),
  isFetching: PropTypes.bool,
  companyEmail: PropTypes.string.isRequired,
  employeeEmail: PropTypes.string.isRequired,
  shiftId: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => ({
  successMessage:
    state.companyEmployeeShift.createReport.successMessage ||
    state.shift.getActiveShift.successMessage,
  errorMessage:
    state.companyEmployeeShift.createReport.errorMessage ||
    state.shift.getActiveShift.errorMessage,
  isFetching:
    state.companyEmployeeShift.createReport.isFetching ||
    state.shift.getActiveShift.isFetching,
});

export default connect(mapStateToProps, {
  createReport,
  getActiveShift,
  getCompanyEmployee,
})(CreateReportForm);



// WEBPACK FOOTER //
// ./src/components/forms/CreateReportForm.js